import { Action, createReducer, on } from '@ngrx/store';
import { IPaymentRunMonthsResponse } from '../dto/payment-run-months.dto';
import * as actions from '../actions';

export const paymentRunMonthsFeatureKey = 'paymentRunMonths';

export interface PaymentRunMonthsState {
  loadPaymentRunMonths: string;
  loadPaymentRunMonthsResponse: IPaymentRunMonthsResponse[];
  isLoaded: boolean;
}

export const initialState: PaymentRunMonthsState = {
  loadPaymentRunMonths: undefined,
  loadPaymentRunMonthsResponse: undefined,
  isLoaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadPaymentRunMonths, (state, action) => ({
    ...state,
    loadPaymentRunMonths: action.businessId
  })),
  on(actions.loadPaymentRunMonthsSuccess, (state, action) => ({
    ...state,
    loadPaymentRunMonthsResponse: action.response,
    isLoaded: true
  }))
);

export const getPaymentRunMonths = (state: PaymentRunMonthsState) => state.loadPaymentRunMonthsResponse;

export const getPaymentRunMonthsIsLoaded = (state: PaymentRunMonthsState) => state.isLoaded;
